// @flow
import React from 'react';
import { EditableInputField } from 'common/components/core/common/CustomEditableField';
import theme from './IntelliSortFeedbackReason.scss';
import { themr } from 'react-css-themr';
import classnames from 'classnames';
import { translate } from 'react-i18next';

import { FieldTypeEnum } from 'common/enums/FieldTypeEnum';

type Props = {
    orderId: string,
    placeholder: string,
    onSave: Function,
    cellText: string
};

class IntelliSortFeedbackReason extends React.PureComponent<Props> {
    handleOnSave = newValue => {
        const { orderId, feedbackStatus, onSave } = this.props;
        return onSave(true, true, orderId, feedbackStatus, newValue, 'reason');
    };

    render() {
        const { placeholder, theme, cellText, isFeedbackActive } = this.props;

        return (
            <EditableInputField
                name={cellText}
                className={classnames(theme.editableInputField, {
                    [theme.placeholder]: !cellText
                })}
                theme={theme}
                placeholder={placeholder}
                customFieldClass={theme.customFieldContainer}
                type={FieldTypeEnum.Text}
                value={cellText}
                onSave={this.handleOnSave}
                isEditingEnabled={isFeedbackActive}
            />
        );
    }
}

const ThemedIntelliSortFeedbackReason = translate()(
    themr('PaginatedTableInputField', theme)(IntelliSortFeedbackReason)
);
export { ThemedIntelliSortFeedbackReason as IntelliSortFeedbackReason };
